import Header from "../../components/Common/Header";
import MainBanner from "../../components/MainBanner";
import SectionBanner from "../../components/SectionBanner";
import ProjectList from "../../components/ProjectList";
import SectionTitleCenter from "../../components/Title/SectionTitleCenter";
import Footer from "../../components/Common/Footer";
import { Lenis as ReactLenis } from "@studio-freight/react-lenis"; // Lenis Provider 추가
import MultipleMarquee from "../../components/MultipleMarqueeLeft";
import BoxAnimation from "../../components/Card/BoxAnimation";
import SectionTitle from "../../components/Title/SectionTitleLeft";

const experticeData = [
  {
    id: 1,
    title: "기획부터 배포까지",
    items: ["기획부터 배포까지의 전 과정 경험"],
  },
  {
    id: 2,
    title: "UI/UX 개선",
    items: ["UI/UX 디자인 개선 및 성능 최적화"],
  },
  {
    id: 3,
    title: "다국어 & Admob",
    items: ["푸시알림, 다국어 지원(i18n)과 Admob 수익화 경험"],
  },
  {
    id: 4,
    title: "프론트엔드",
    items: ["React, React Native, HTML, CSS, JavaScript, Thymeleaf"],
  },
  {
    id: 5,
    title: "백엔드",
    items: ["Firebase, RESTful API 연결 경험"],
  },
  {
    id: 6,
    title: "기타",
    items: ["Admob, i18n(다국어 지원), UX/UI 디자인, 기획 참여 및 PM 경험"],
  },
];

export default function HomeScreen() {
  return (
    <ReactLenis root>
      <div className="page__content bg-black text-white page__content--with-header page__content--with-bottom-nav mx-auto">
        <Header logo="/logo-w.png" />
        <MainBanner
          firstTitle="Portfolio"
          lastName="Piao"
          firstName="Yingying"
          desc="웹 및 모바일 애플리케이션 개발자, 프론트엔드와 풀스택 경험 보유 ,React Native, Firebase, Spring Boot 등에 능숙하며 프로젝트 기획부터 배포까지 담당"
          img="https://i.pinimg.com/736x/db/c5/ea/dbc5ea4bacfe256501873e8e628b3e72.jpg"
        />
        <SectionBanner />
        <BoxAnimation />
        <MultipleMarquee />
        <div className="max-w-5xl m-auto">
          <SectionTitle title="웹 및 모바일 애플리케이션 개발 경험" />
          <div class="grid gap-6 divide-y  text-white bg-black max-w-5xl mx-auto">
            {experticeData.map((map) => (
              <div
                class="flex items-center justify-between py-4"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration={map.id * 400}
              >
                <span class="text-2xl font-bold ">{map.title}</span>
                <p class="text-base text-gray-300">{map.items}</p>
              </div>
            ))}
          </div>
        </div>
        <SectionTitleCenter
          sectionTitle="Project"
          sectionSubTitle="웹 및 모바일 개발 경력과 주요 프로젝트 사례"
        />
        <ProjectList />
        <Footer
          email="oying212@icloud.com"
          desc="웹과 모바일 환경에서 사용자 경험을 개선하고, 비즈니스 성장에 기여하는 개발자가 되겠습니다."
        />
      </div>
    </ReactLenis>
  );
}
